var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStageView = function SvgStageView(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 26 25"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M24 21H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h22a2 2 0 0 1 2 2v17a2 2 0 0 1-2 2M2.624 1.658a1 1 0 0 0-1 1v15.684a1 1 0 0 0 1 1h20.75a1 1 0 0 0 1-1V2.658a1 1 0 0 0-1-1zM17 23.001H1a1 1 0 1 0 0 2h16a1 1 0 1 0 0-2M25 23.001h-4a1 1 0 1 0 0 2h4a1 1 0 1 0 0-2"
  })));
};
export default SvgStageView;